import { toastManager as e } from "@systemeio/components";
//#region src/components/toast.ts
var t = { error: (t) => e.add({
	type: "error",
	title: t
}) };
//#endregion
export { t as toast };
